import React from 'react'
import { connect } from 'react-redux'
import * as fundActions from 'actions/fund'
import { setUser } from 'actions/dashboard'
import { db } from 'utils/firebase'
import * as selectors from 'selectors'

const loadUserAndFetchFunds = Component => {
  class LoadUser extends React.Component {
    componentWillUnmount = () => {
      this.listener.off('value', this.onNewValue)
      this.listener = undefined
    }

    componentWillMount = () => {
      const { currentUserUid, setUser } = this.props
      this.userId = currentUserUid
      setUser(this.userId)
      this.listener = db.ref(`funds/${this.userId}`)
      this.listener.on('value', this.onNewValue)
    }

    first = true

    onNewValue = snapshot => {
      this.props.setFundsSnapshot({ snapshot, userId: this.userId })
      if (this.first) {
        this.first = false
        this.props.fetchHashFundsQuantities()
        this.props.fetchHistories()
      }
    }
    render() {
      return <Component {...this.props} />
    }
  }
  const mapStateToProps = state => ({
    currentUserUid: selectors.currentUserUid(state),
  })
  const mapDispatchToProps = (dispatch, ownProps) => ({
    setFundsSnapshot: d => dispatch(fundActions.setFundsSnapshot(d)),
    setUser: d => dispatch(setUser(d)),
    fetchHashFundsQuantities: () =>
      dispatch(fundActions.fetchHashFundsQuantities()),
    fetchHistories: () => dispatch(fundActions.fetchHistories()),
  })
  return connect(mapStateToProps, mapDispatchToProps)(LoadUser)
}

export default loadUserAndFetchFunds



// WEBPACK FOOTER //
// ./src/utils/loadUserAndFetchFunds.js